import { useEffect, useRef, memo } from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import { WithLoadingSpinner } from "@rentablo/components";
import { useChartOptions } from "./useChartOptions";

export type DonutChartItem = {
  id: string;
  name: string;
  value: number;
  currency: string;
  color?: string;
  childrenNumber?: number;
  y: number;
};

type Props = {
  chartData?: DonutChartItem[];
  chartColors?: string[];
  width?: number;
  height?: number;
  isLoading?: boolean;
};

export const DonutChart = memo((props: Props) => {
  const {
    chartData,
    chartColors,
    width = 340,
    height = 340,
    isLoading,
  } = props;
  const chartComponentRef = useRef<HighchartsReact.RefObject>(null);

  const chartOptions = useChartOptions(width, height, chartColors, chartData);

  useEffect(() => {
    if (!chartComponentRef.current?.chart?.series[0]?.finishedAnimating) return;
    chartComponentRef.current.chart.reflow();
  }, [chartOptions]);

  return (
    <WithLoadingSpinner
      isLoading={Boolean(isLoading)}
      style={{ height: height }}
    >
      {!isLoading && (
        <HighchartsReact
          highcharts={Highcharts}
          ref={chartComponentRef}
          options={chartOptions}
          isLoading={Boolean(isLoading)}
        />
      )}
    </WithLoadingSpinner>
  );
});
